/* FSA/HSA badge tooltip on PRODUCT CARDS. A card's tooltip can extend into the
   neighbouring card, whose content then paints over it (each card is its own
   stacking context on hover). Fixing this with z-index alone isn't reliable, so on
   hover/focus we switch the card tooltip to position:fixed (escaping every card's
   stacking context) and place it just under the badge, clamped to the viewport.
   Event delegation so it also covers cards added later (filtered/sorted grids).
   The product-page tooltip is left as-is (plain CSS works there). */
(function () {
  if (window.__llmFsaTipInit) return;
  window.__llmFsaTipInit = true;

  /* Where a position:fixed child of `tip` actually measures its left/top from.

     `fixed` is only viewport-relative when NOTHING up the tree has a transform, filter,
     perspective, backdrop-filter, contain or a will-change naming one — any of those makes that
     ancestor the containing block instead. <product-card> carries `transform: matrix(1,0,0,1,0,0)`,
     an IDENTITY transform that changes nothing visually but still counts, so this applies to every
     product card on the site.

     That is why the owner reported "tooltips aren't working" three times: the tooltip WAS opening
     and WAS visible, but left:525px was measured from the card (whose left edge is 512), landing it
     at x=1038 — about 513px to the right of the badge, floating over the neighbouring card instead
     of under the cursor. Every fix before this one was aimed at z-index and hover detection, which
     were never the problem. Measured on the live grid, not inferred.

     Returns the origin to subtract, or {0,0} when the viewport really is the containing block. */
  function fixedOrigin(tip) {
    var n = tip.parentElement;
    while (n && n !== document.documentElement) {
      var c = getComputedStyle(n);
      if ((c.transform && c.transform !== 'none') ||
          (c.perspective && c.perspective !== 'none') ||
          (c.filter && c.filter !== 'none') ||
          (c.backdropFilter && c.backdropFilter !== 'none') ||
          /transform|perspective|filter/.test(c.willChange || '') ||
          /paint|layout|strict|content/.test(c.contain || '')) {
        var b = n.getBoundingClientRect();
        return { left: b.left, top: b.top };
      }
      n = n.parentElement;
    }
    return { left: 0, top: 0 };
  }

  function place(trigger, tip) {
    if (!tip) return;
    var r = trigger.getBoundingClientRect();
    tip.style.position = 'fixed';
    tip.style.zIndex = '99999';

    /* Clamping below is all done in VIEWPORT coordinates, because that is what the viewport edges
       and the sticky bar are expressed in. The containing-block offset is subtracted only at the
       final assignment. */
    var origin = fixedOrigin(tip);

    var left = r.left;
    /* Desktop list view right-aligns the price column, so a tip hung off the trigger's LEFT edge
       ran past the card (owner 2026-10-26). There, end it at the trigger's right edge instead. */
    if (window.innerWidth >= 1024 && trigger.closest('.main-products-grid[data-layout="list"]')) {
      left = r.right - tip.offsetWidth;
    }
    var maxLeft = window.innerWidth - tip.offsetWidth - 8;
    if (left > maxLeft) left = Math.max(8, maxLeft);
    tip.style.left = Math.round(left - origin.left) + 'px';

    /* Vertical placement. This used to be an unconditional `top: r.bottom + 8`, which on mobile
       dropped the tooltip straight onto the sticky Add-to-cart bar for any card low in the viewport
       — recently-viewed especially, since it sits near the end of the page (owner 2026-09-06).
       z-index cannot solve it: the tip is deliberately 99999 to escape each card's stacking context,
       so it is ABOVE the sticky bar (5), the cart drawer (1010) and everything else by design.
       Placement, not stacking, is the thing to fix.

       The floor is the sticky bar's top edge when that bar is actually showing — it is
       visibility:hidden until the real Add-to-cart scrolls out of view, and display:none on desktop,
       so both are checked rather than assuming its box means it is visible. */
    var floor = window.innerHeight;
    var bar = document.querySelector('.sticky-atc-panel');
    if (bar) {
      var bs = getComputedStyle(bar);
      if (bs.display !== 'none' && bs.visibility !== 'hidden') {
        var brect = bar.getBoundingClientRect();
        if (brect.height > 0) floor = brect.top;
      }
    }

    var h = tip.offsetHeight;            // measurable: the hidden state is visibility, not display
    var below = r.bottom + 8;
    var top;
    if (below + h <= floor - 8) top = below;               // fits underneath — preferred
    else if (r.top - 8 - h >= 8) top = r.top - 8 - h;      // no room: flip above the badge
    else top = Math.max(8, floor - 8 - h);                 // neither fits: sit just clear of the bar
    tip.style.top = Math.round(top - origin.top) + 'px';
  }

  function fromEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return null;

    var b = t.closest('.card__fsa .llm-fsa-badge--compact');
    if (b) {
      /* The slider / buy-it-again skip that used to be here was removed 2026-09-07 along with the
         CSS that hid those tooltips — its premise (a transform containing block in the carousel)
         was measured to be false, and it was silently disabling the tooltip on recently-viewed,
         recommendations, featured-collection, saved-row and cart recs. See main.css. */
      return { trigger: b, tip: b.querySelector('.llm-fsa-badge__tip') };
    }

    /* The card's "Autoship" term has exactly the same problem and needed the same escape: on desktop
       its tooltip is absolutely positioned inside .llm-card-autoship__text, so the neighbouring card
       clipped its right-hand side (owner 2026-09-06). Its tip is a SIBLING of the trigger, inside
       .llm-card-autoship — not a descendant like the FSA one. */
    var a = t.closest('.llm-card-autoship__info');
    if (a) {
      var wrap = a.closest('.llm-card-autoship');
      return { trigger: a, tip: wrap && wrap.querySelector('.llm-card-autoship__tip') };
    }
    return null;
  }

  /* NO DEVICE GATE HERE — deliberately. Two were tried and both broke desktop by disabling this
     while llm-info-sheet.js also declined to act, leaving the badge doing nothing at all (owner
     2026-09-06, twice): `max-width: 749.98px` fails on a zoomed desktop, and
     `(hover: hover) and (pointer: fine)` fails on a desktop with a touchscreen.

     Positioning a tooltip that is hidden costs nothing, so this now always runs. On touch the sheet
     takes over and the CSS hides these tips — but only AFTER a real touch is observed, so a mouse
     user can never end up with neither.

     An earlier attempt also added touchstart/click here to force place() before the CSS :hover could
     open the tooltip. Removed: it was defending a popover that cannot win its stacking context,
     instead of replacing it. */

  // pointerover/focusin bubble, so delegation covers dynamically-rendered cards.
  document.addEventListener('pointerover', function (e) {
    var s = fromEvent(e); if (s) place(s.trigger, s.tip);
  }, true);
  document.addEventListener('focusin', function (e) {
    var s = fromEvent(e); if (s) place(s.trigger, s.tip);
  });
})();
